<template>
  <div class="section">
    <filer-screens-nav />
    <router-view />
  </div>
</template>
<script>
import FilerScreensNav from '@/components/FilerScreensNav.vue';
export default {
  components: {
    FilerScreensNav,
  },
};
</script>